import { Component, ElementRef, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderTitle } from '@app/shared/common/header-title/header-title.model';
import { HeaderTitleService } from '@app/shared/common/header-title/header-title.service';
import { ModalDeletePopupComponent } from '@app/shared/common/modal-popup/modal-delete-popup/modal-delete-popup.component';
import { ModalPopupComponent } from '@app/shared/common/modal-popup/modal-popup/modal-popup.component';
import { BreadcrumbItem } from '@app/shared/common/sub-header/sub-header.component';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { AppRoutes } from '@app/shared/routes/app-routes';
import { AppComponentBase } from '@shared/common/app-component-base';
import { BlobHelperServiceProxy, CityMasterDto, ClientContactCreateOrEditDto, ClientCreateOrEditDto, ClientServiceProxy, CompanyProfileCountryLookupTableDto, CountryMasterDto, CountryStateCityAppserviceServiceProxy, SettingScopes, StateMasterDto, StoreImageOnBlobDto, UserServiceProxy } from '@shared/service-proxies/service-proxies';
import { AbpSessionService } from 'abp-ng2-module';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { ChargeLateFeesComponent } from './charge-late-fees/charge-late-fees.component';
import { CurrencyLanguageComponent } from './currency-language/currency-language.component';
import { SendPaymentRemainderComponent } from './send-payment-remainder/send-payment-remainder.component';
import { PhoneNumberUtil, PhoneNumberFormat, AsYouTypeFormatter, PhoneNumberType } from 'google-libphonenumber';
import { AppConsts } from '@shared/AppConsts';
import { getPostalCodeMaxLength, getPostalCodeRule, isPostalCodeValid, sanitizePostalCode } from '@app/shared/common/validation/postal-code';

@Component({
    standalone: false,
    selector: 'app-create-or-edit-client',
    templateUrl: './create-or-edit-client.component.html',
    styleUrls: ['./create-or-edit-client.component.css']
})
export class CreateOrEditClientComponent extends AppComponentBase implements OnInit {
    @ViewChild('clientForm', { static: true }) clientForm: NgForm;
    @ViewChild('sendPaymentReminderSetting', { static: true }) sendPaymentReminderSetting: SendPaymentRemainderComponent;
    @ViewChild('chargeLateFee', { static: true }) chargeLateFeesComponent: ChargeLateFeesComponent;
    @ViewChild('currencyLanguage', { static: true }) currencyLanguageComponent: CurrencyLanguageComponent;
    @ViewChild("appModalPopup") appModalPopup: ModalPopupComponent;
    @ViewChild("appModaldeletePopup") appModaldeletePopup: ModalDeletePopupComponent;
    @Output() clientAdded: EventEmitter<void> = new EventEmitter<void>();
    @ViewChild("appChangeRouteModalPopup") appChangeRouteModalPopup: ModalPopupComponent;
    @ViewChild('orgMobPhone', { static: true }) orgMobPhoneNgModel: NgModel;
    @ViewChild('clientTimezone', { static: false }) clientTimezoneNgModel: NgModel;
    @ViewChild('zipCodeInput') zipCodeInput: ElementRef<HTMLInputElement>;
    ActiveClient = "Active Client";
    isLoading = false;
    addForm1stTime = false;
    toggleChecked = false;
    toggleSetting = false;
    ison1 = false;
    ison2 = false;
    imagePath = '';
    isFormDisabled = false;
    subHeaderText = '';
    subHeaderText1 = '';
    option: number;
    allCountry: CompanyProfileCountryLookupTableDto[] = [];
    editIndexClientContactData = -1;
    visited = [0, 0, 0];
    number = ['Charge', 'Setting', 'Currency'];
    checked = false;
    flagselected = '';
    clientData: ClientCreateOrEditDto = new ClientCreateOrEditDto();
    clientContactData: ClientContactCreateOrEditDto[] = [];
    singleContactDetail: ClientContactCreateOrEditDto = new ClientContactCreateOrEditDto();
    defaultTimezoneScope: SettingScopes = SettingScopes.User;
    roleOptions = [{ roleId: 1, roleName: this.l('TechnicalContact') }, { roleId: 2, roleName: this.l('BillingContact') }];
    isSubmited = false;
    isEmailExist = false;
    isPrimaryContactAdded = false;
    clientId: number;
    IsAddingContact = false;
    statebycountryId: StateMasterDto[] = [];
    CityList : CityMasterDto[] = [];
    allCountryCOde: CountryMasterDto[] = [];
    navigationUrl: string;
    indexTodeleteClientContact: number;
    dateTime = new Date();
    msg: string;
    existingEmail: string;
    isOnlySpaceInString: boolean = false;
    isdisablestate:boolean = true
    isdisablecity: boolean = true
    mobilephoneFlag: string = ''
    timmer: any
    Phonecountrycode: string;
    phoneDialCode: string = '';
    nationalPhoneNumber: string = '';
    phonePlaceholder: string = '';
    phoneFormatExample: string = '';
    nationalDigitLimit: number = 15;
    validatenymber: boolean = true;
    mobilenumber: boolean = true;

    constructor(injector: Injector,
        private _router: Router,
        private _activatedRoute: ActivatedRoute,
        private _blobHelperServiceProxy: BlobHelperServiceProxy,
        private _spinnerService: NgxSpinnerService,
        private _clientServiceProxy: ClientServiceProxy,
        private headerTitleService: HeaderTitleService,
        private toastr: ToastrService,
        private _userServiceProxy: UserServiceProxy,
        private _abpSessionService: AbpSessionService,
        private _monitorService: MonitoringService,
        private _countryStateCityAppserviceServiceProxy :CountryStateCityAppserviceServiceProxy) {
        super(injector);
    }

    ngOnInit(): void {
        this.msg = "userId = " + this._abpSessionService.userId + "tenantId =" + this._abpSessionService.tenantId;
        this._monitorService.logPageView("UI-CreateOrEdit");

        this.clientId = Number(this._activatedRoute.snapshot.queryParams.ClientId);
        this.option = Number(this._activatedRoute.snapshot.queryParams.option);
        this.clientId = Number(history.state.ClientId);
        this.option = Number(history.state.option);
        this.show(this.clientId);
        if (this.option === 1) {
            this.isFormDisabled = false;
            this.subHeaderText1 = this.l('ActiveClients');
            this.subHeaderText = this.l('EditClient');
        } else if (this.option === 2) {
            this.isFormDisabled = false;
            this.subHeaderText1 = this.l('ActiveClients');
            this.subHeaderText = this.l('EditClient');
        }
        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem(this.l('Clients')),
            new BreadcrumbItem(this.subHeaderText1),
            new BreadcrumbItem(this.subHeaderText)
        ]));
        this.GetallCountryCOde();
        this.updatePhonePlaceholder();
    }

    ngOnDestroy(): void {

    }

    //For confirm leave form guard
    canceledSaved: boolean = false;
    shouldConfirmBeforeLeavingComponent() {
        return !this.canceledSaved;
    }

    //For confirm leave form guard
    changeRoute: any;
    changeRouteResolve: any;
    changeRouteReject: any;
    async showChangeRouteModal() {

        var component = this;

        return new Promise<boolean>((resolve, reject) => {
            this.spinnerService.hide();
            this.appChangeRouteModalPopup.show(2);

            component.changeRouteResolve = resolve;
            component.changeRouteReject = reject;
        });
    }

    changeRouteModalYes(event) {

        this.changeRouteResolve(true);
    }

    changeRouteModalCancel() {
        this.changeRouteResolve(false);
    }

    toggleOnoffevent(event) {
        if (!this.sendPaymentReminderSetting.isCheck && !this.addForm1stTime) {
            this.sendPaymentReminderSetting.addForm();
            this.addForm1stTime = true;
        }
        this.ison2 = !this.ison2;
    }
    changechargeonoff(event) {
        if (this.chargeLateFeesComponent.isCheck) {
            this.chargeLateFeesComponent.isCheck = event.target.checked;
        }
        this.ison1 = !this.ison1;
    }
    changeCharge(event) {
        this.toggleChecked = event;
        this.ison2 = !this.ison2;
    }

    chargeLateFeeFunction(event) {
        this.toggleSetting = event;
        this.ison1 = !this.ison1;
    }

    displayCounter(count) {
        this.imagePath = count;
    }

    show(clientId?: number) {
        this.subHeaderText1 = this.l('ActiveClients');
        this.subHeaderText = this.l('NewClient');
        if (clientId) {
            this.isLoading = true;

            this._spinnerService.show();
            this._clientServiceProxy.getClientById(clientId).subscribe(result => {
                this._spinnerService.hide();
                this.imagePath = result.clientImageURL;
                this.clientData = result;
                if (result.chargeLateFee !== undefined) {
                    result.chargeLateFee.charelateFeeTaxDetail = result.charelateFeeTaxDetail;
                }

                this.clientData.countryId = result.countryId;
                this.updateZipCountryFromSelection();

                this.clientContactData = result.clientContacts;
                this.clientContactData.forEach(contact => {
                    if (contact.isPrimary) {
                        this.isPrimaryContactAdded = true;
                    }
                })
                if (result.paymentReminder.length !== 0) {
                    this.ison2 = true;
                }
                if (result.chargeLateFee !== undefined) {
                    if (result.chargeLateFee.invoiceValue !== 0 || result.chargeLateFee.invoiceValue !== 0) {
                        this.ison1 = true;
                    }
                }
                this.getStateByCountryId(result.countryId)
                this.getcityByStateId(result.state)
                if (!this.singleContactDetail?.phoneNumber) {
                    this.applyDefaultPhoneCountry();
                }

            });
        }

    }

    close() {
        this.appModalPopup.show(2);
    }
    cancelNavigationtoUser() {

    }
    navigateToClient() {
        this.canceledSaved = true;
        if (this.navigationUrl) {
            this._router.navigate([this.navigationUrl]);
            return;
        }

        this._router.navigate([AppRoutes.clients]);
        this.clientAdded.emit();

    }

    //Not allow to insert Special character by keybord
    keyPressAlphaNumeric(event) {
        var inp = String.fromCharCode(event.keyCode);
        if (/[a-zA-Z0-9\w\s]/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }
    keyPressAlphabatesonly(event) {
        var inp = String.fromCharCode(event.keyCode);
        if (/^[a-zA-Z ]*$/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }

    keyPressAlphabatesvalidation(event) {
        if (event.keyCode == 32) return false;
        var inp = String.fromCharCode(event.keyCode);
        if (/^[a-zA-Z ]*$/.test(inp)) {
            return true;
        } else {
            event.preventDefault();
            return false;
        }
    }

    save() {
        this.clientForm.form.markAllAsTouched();
        this.clearEmptyContactDraftValidation();

        const validationMessage = this.getClientSaveValidationMessage();
        if (validationMessage) {
            this.toastr.warning(validationMessage);
            return;
        }

        this._monitorService.logTrace("UI-Save", { "SaveClient ": "start: " + this + this.dateTime });

        this.isOnlySpaceInString = false;
        this.canceledSaved = true;

        if (this.clientData.id) {
            this.checkDuplicate(this.clientData.name, this.clientData.id, true);
        } else {
            this.checkDuplicate(this.clientData.name);
        }

        this._monitorService.logTrace("UI-Save", { "SaveClient ": "Completed: " + this + this.dateTime });
    }

    private clearEmptyContactDraftValidation(): void {
        if (!this.clientContactData.length) {
            return;
        }

        const draftControlNames = ['firstName', 'lastName', 'email', 'clientContactRoleId', 'orgMobPhone'];
        draftControlNames.forEach((controlName) => {
            const control = this.clientForm.controls[controlName];
            if (!control) {
                return;
            }

            const value = control.value;
            if (value === null || value === undefined || value === '') {
                control.setErrors(null);
                control.markAsPristine();
                control.markAsUntouched();
            }
        });

        this.orgMobPhoneNgModel?.control?.setErrors(null);
        this.mobilenumber = true;
        this.validatenymber = true;

        this.clientForm.form.updateValueAndValidity();
    }

    private getClientSaveValidationMessage(): string | null {
        if (!this.clientData.name?.trim()) {
            return this.l('CompanyNameIsRequired');
        }
        if (!this.clientData.street) {
            return this.l('AddressIsRequired');
        }
        if (!this.clientData.countryId) {
            return this.l('CountryIsRequired');
        }
        if (!this.clientData.state) {
            return this.l('StateIsRequired');
        }
        if (!this.clientData.city) {
            return this.l('CityIsRequired');
        }
        if (!this.clientData.zipCode) {
            return this.l('ZIPCodeIsRequired');
        }
        if (!isPostalCodeValid(this.clientData.zipCode, this.selectedCountryIso2)) {
            return this.l('ZIP code format does not match country');
        }
        this.syncTimezoneValue();
        if (!this.clientData.timeZone) {
            return this.l('TimeZoneIsRequired');
        }
        if (this.clientContactData.length === 0) {
            return this.l('PleaseaddatleastoneContactPerson');
        }
        if (!this.hasPrimaryContact()) {
            return 'Add a Primary Contact';
        }

        return null;
    }

    isClientReadyToSave(): boolean {
        return this.getClientSaveValidationMessage() === null;
    }

    private hasPrimaryContact(): boolean {
        return this.isPrimaryContactAdded || this.clientContactData.some((contact) => contact.isPrimary);
    }

    private syncTimezoneValue(): void {
        const timeZoneValue = this.clientData.timeZone || this.clientTimezoneNgModel?.control?.value || 'Default';
        this.clientData.timeZone = typeof timeZoneValue === 'string' ? timeZoneValue : timeZoneValue?.value;
    }

    deletePicture() {
        this.imagePath = '';
    }

    addContact(event) {
        this._monitorService.logEvent("addContact", { "addContact": "Start: " + this.msg + this.dateTime });

        event.stopPropagation();
        this.IsAddingContact = true;
        if (this.isEmailExist) {
            return;
        }
        else if (!this.getNationalDigits() || !this.mobilenumber || !this.validatenymber) {
            return;
        }
else if (this.singleContactDetail.firstName && this.singleContactDetail.phoneNumber
            && this.singleContactDetail.firstName && this.singleContactDetail.clientContactRoleId
            && this.clientForm.controls['email'].valid) {
            if (this.singleContactDetail.isPrimary) this.isPrimaryContactAdded = true;
            if (this.editIndexClientContactData === -1) {
                this.singleContactDetail.firstName = this.singleContactDetail.firstName.trim();
                this.singleContactDetail.lastName = this.singleContactDetail.lastName.trim();
                this.clientContactData.push(this.singleContactDetail);
                this.singleContactDetail = new ClientContactCreateOrEditDto();
                this.resetContactPhoneState();
            } else if(!this.isEmailExist){

                this.singleContactDetail.clientId = this.clientContactData[this.editIndexClientContactData].clientId;
                this.singleContactDetail.id = this.clientContactData[this.editIndexClientContactData].id;

                this.clientContactData[this.editIndexClientContactData] = this.singleContactDetail;
            }
            this.IsAddingContact = false;
            this.isEmailExist = false;
            this.editIndexClientContactData = -1;
            this.singleContactDetail = new ClientContactCreateOrEditDto();
            this.singleContactDetail.lastName = null;
            this.singleContactDetail.firstName = null;
            this.singleContactDetail.email = null;
            this.singleContactDetail.phoneNumber = null;
            this.singleContactDetail.clientContactRoleId = null;
            this.resetContactPhoneState();
        }
        this._monitorService.logEvent("addContact", { "addContact": "Completed: " + this.msg + this.dateTime });

    }

    removefromClientContactData(index: number, contactData: ClientContactCreateOrEditDto) {
        this.indexTodeleteClientContact = index;
        this.appModaldeletePopup.show();
    }

    editfromClientContactData(index: number) {
        this._monitorService.logEvent("editfromClientContactData", { "editfromClientContactData": "Editcontact:index no= " + index + this.msg + this.dateTime });
        this.isEmailExist = false;

        this.editIndexClientContactData = index;
        if (this.clientContactData[index].isPrimary) this.isPrimaryContactAdded = false;
        this.singleContactDetail.firstName = this.clientContactData[index].firstName;
        this.singleContactDetail.lastName = this.clientContactData[index].lastName;
        this.singleContactDetail.email = this.clientContactData[index].email;
        this.existingEmail = this.clientContactData[index].email;
        this.singleContactDetail.phoneNumber = this.clientContactData[index].phoneNumber;
        this.singleContactDetail.isPrimary = this.clientContactData[index].isPrimary;
        this.singleContactDetail.clientContactRoleId = this.clientContactData[index].clientContactRoleId;

        if (this.singleContactDetail.phoneNumber) {
            this.GetallCountryCOde();
        } else {
            this.resetContactPhoneState();
        }
    }

    private resetContactPhoneState(): void {
        this.nationalPhoneNumber = '';
        if (this.singleContactDetail) {
            this.singleContactDetail.phoneNumber = null;
        }
        this.applyDefaultPhoneCountry();
        this.setPhoneValidationState(true);
    }

    toggleEditMode() {
        this.isFormDisabled = !this.isFormDisabled;
        this.subHeaderText = this.isFormDisabled ? this.l('ViewClient') : this.l('EditClient');
    }

    companyNameAlreadyExists: boolean = false;
    checkDuplicate(clientName: string, clientId?: number, isEdit?: boolean) {

        this._clientServiceProxy.checkDuplicateClient(clientName, clientId, isEdit).subscribe((res) => {
            if (!res) {
                this.companyNameAlreadyExists = false;
                this.saveClientData();
            } else {
                this.companyNameAlreadyExists = true;
                this.toastr.warning(this.l('CompanyNameAlreadyExists'));
            }
        });
    }

    NameVerify(clientName: string, clientId?: number, isEdit?: boolean) {
        if (clientName == ' ') {
            return;
        }
        this._clientServiceProxy.checkDuplicateClient(clientName, clientId, isEdit).subscribe((result) => {
            if (result == true) {
                this.companyNameAlreadyExists = true;
            } else {
                this.companyNameAlreadyExists = false;
            }
        });
    }

    onlyNumberKey(event) {
        if (event.charCode === 45) return true;
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }

    // To return title case string
    getTitleCase(s: string) {
        let char = s[0].toUpperCase();
        return char + s.slice(1)?.toLowerCase();
    }

    saveClientData() {
        try {
            this._monitorService.logEvent("saveClientData", { "saveClientData": "Start: " + this.msg + this.dateTime });
            if (!this.hasPrimaryContact()) {
                this.toastr.warning('Add a Primary Contact');
                return;
            }
            this.isLoading = true;
            this._spinnerService.show();
            if (this.clientContactData.length > 0) {
                if (this.isSubmited) return;
                this.isSubmited = true;
                //To make client contacts first and last name title case
                this.clientContactData.forEach(x => {
                    x.firstName = this.getTitleCase(x.firstName);
                    x.lastName = this.getTitleCase(x.lastName);
                })
                this.clientData.clientContacts = this.clientContactData;

                let blobImgDto = new StoreImageOnBlobDto();
                blobImgDto.imgBase64String = this.imagePath ? this.imagePath.split(',')[1] : null;
                blobImgDto.tenantId = this.appSession.tenant.id;
                this._blobHelperServiceProxy.getUrlAfterImageBlobStorage(blobImgDto).subscribe({
                    next: (imgLink) => {
                    this.clientData.clientImageURL = imgLink ? imgLink : this.imagePath;
                    if (this.clientData.id === 0 || this.clientData.id === undefined || this.clientData.id === null) {
                        // this.clientData.paymentReminder = this.sendPaymentReminderSetting.paymentReminderSetting();
                        // this.clientData.chargeLateFee = this.chargeLateFeesComponent.chargeLateFee();
                        // this.clientData.currencyId = this.currencyLanguageComponent.getCurrencyId();
                        // this.clientData.applicationLanguageId = this.currencyLanguageComponent.getLanguageId();
                        //this.clientData.charelateFeeTaxDetail=this.chargeLateFeesComponent.TaxDataFromCommonComponent();
                    } else {
                        // this.clientData.paymentReminder = this.sendPaymentReminderSetting.paymentReminderSetting();

                        // if (this.chargeLateFeesComponent.chargeLateFee().feeValueType != undefined) {
                        //     this.clientData.chargeLateFee.feeValueType = this.chargeLateFeesComponent.chargeLateFee().feeValueType === null || this.chargeLateFeesComponent.chargeLateFee().feeValueType === undefined ? this.clientData.chargeLateFee.feeValueType : this.chargeLateFeesComponent.chargeLateFee().feeValueType;
                        //     this.clientData.chargeLateFee.days = this.chargeLateFeesComponent.chargeLateFee().days === null || this.chargeLateFeesComponent.chargeLateFee().days === undefined ? this.clientData.chargeLateFee.days : this.chargeLateFeesComponent.chargeLateFee().days;
                        //     this.clientData.chargeLateFee.invoiceValue = this.chargeLateFeesComponent.chargeLateFee().invoiceValue === null || this.chargeLateFeesComponent.chargeLateFee().invoiceValue === undefined ? this.clientData.chargeLateFee.invoiceValue : this.chargeLateFeesComponent.chargeLateFee().invoiceValue;
                        //     this.clientData.chargeLateFee.charelateFeeTaxDetail = this.chargeLateFeesComponent.chargeLateFee().charelateFeeTaxDetail === null || this.chargeLateFeesComponent.chargeLateFee().charelateFeeTaxDetail === undefined ? this.clientData.chargeLateFee.charelateFeeTaxDetail : this.chargeLateFeesComponent.chargeLateFee().charelateFeeTaxDetail;
                        // }

                        //   this.clientData.charelateFeeTaxDetail=this.chargeLateFeesComponent.TaxDataFromCommonComponent() === null || this.chargeLateFeesComponent.TaxDataFromCommonComponent() === undefined ? this.clientData.charelateFeeTaxDetail : this.chargeLateFeesComponent.TaxDataFromCommonComponent();
                        //this.clientData.charelateFeeTaxDetail=this.chargeLateFeesComponent.TaxDataFromCommonComponent();

                        // this.clientData.currencyId = this.currencyLanguageComponent.getCurrencyId();
                        // this.clientData.applicationLanguageId = this.currencyLanguageComponent.getLanguageId();
                    }
                    this._monitorService.logTrace("UI-saveClientData", { "saveClientData ": "CreateOrEdit:called " + this + this.dateTime + "InputData:" + null })
                    //if(this.isSubmited) return;
                    this.clientData.country = null;
                    this.clientData.city = this.clientData.city === null ? 0 : this.clientData.city;
                    this.clientData.state = this.clientData.state === null ? 0 : this.clientData.state; 
                    this._clientServiceProxy.createOrEdit(this.clientData)
                        .pipe(finalize(() => {
                            this._spinnerService.hide();
                            this.isSubmited = false;
                        }))
                        .subscribe(() => {
                            this.clientData.id ? this.toastr.success(this.l("Changesupdatedsuccessfully")) : this.toastr.success(this.l("Newclientaddedsuccessfully"));

                            this.clientAdded.emit();
                            this._router.navigate([AppRoutes.clients]);
                        });
                    },
                    error: () => {
                        this.isSubmited = false;
                        this._spinnerService.hide();
                        this.toastr.error(this.l('Error'));
                    }
                });

            } else {
                this._monitorService.logTrace("UI-saveClientData", { "saveClientData ": "Please add At least one contact person: " + this + this.dateTime })
                this.isSubmited = false;
                this._spinnerService.hide();
                abp.message.info('', this.l('PleaseaddatleastoneContactPerson'));
            }
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    SelectedCountry(event: CompanyProfileCountryLookupTableDto) {
        if (!event) this.flagselected = '';
        this.allCountry.forEach(x => { if (x.id === event.id) this.flagselected = x.flag });
    }
    
    countryselection(event: any) {
        this.clientData.state = null;
        this.clientData.city = null;
        this.statebycountryId = null;
        this.CityList = null;

        this.clientData.countryId = event;
        this.getStateByCountryId(event);
        this.updateZipCountryFromSelection();
        if (!this.getNationalDigits()) {
            this.applyDefaultPhoneCountry();
        }
    }
    stateselection(event: any) {

        this.clientData.countryId = event;

    }

    EmailVerify(value: any) {
        const email = value?.trim()?.toLowerCase();

        if(email) {
            this.isCheckEmail(email).then((result) => {
                if (this.singleContactDetail.email?.trim()?.toLowerCase() !== email) {
                    return;
                }
                if (result == true) {
                    this.isEmailExist = true;
                } else {
                    this.isEmailExist = false;
                }

            }).then(() => {
                if (this.singleContactDetail.email?.trim()?.toLowerCase() !== email) {
                    return;
                }
                let emailExist = this.clientContactData.find(x => x.email?.trim()?.toLowerCase() === email);
                if (emailExist) {
                    this.isEmailExist = true;
                }
            });
        }
        else {
            this.isEmailExist = false;
        }
    }

    async isCheckEmail(value: any) {
        try {
            const result = await firstValueFrom(
                this._userServiceProxy.isCheckEmail(value)
            );
            return result;
        } catch (error) {
            abp.log.error('Error checking email: ' + error);
            return false;
        }
    }

    getFullname(name: string, lastname: string) {
        return name + " " + lastname;
    }
    onModalYesClick(id) {
        if (this.clientContactData[this.indexTodeleteClientContact].isPrimary) this.isPrimaryContactAdded = false;
        this.clientContactData.splice(this.indexTodeleteClientContact, 1);
    }

    onModalCancelClick() {
    }

    onCompanyChange() {
        this.companyNameAlreadyExists = false;
        this.isOnlySpaceInString = false;
    }

    SelectedCity(event : any){
        this.clientData.city = event?.id ?? event;
      }

    filterCountryCOde: CountryMasterDto[] = [];

      getStateByCountryId(countryId: number ) {
        this._countryStateCityAppserviceServiceProxy.getStateByCountryId(countryId).subscribe(result => {
            this.statebycountryId = result.filter((country) => {
                return country.name !== '';
            }).sort((a, b) => a.name.localeCompare(b.name));
            this.isdisablestate = false

        });
      }

      getcityByStateId(stateId :number) {
        this._countryStateCityAppserviceServiceProxy.getCityByCountryId(stateId).subscribe(result => {
            this.CityList = result.filter((country) => {
                return country.name !== '';
            }).sort((a, b) => a.name.localeCompare(b.name));
            this.isdisablecity = false
        });
      }
      SelectedState(event : any){
        const stateId = event?.id ?? event;
        this.getcityByStateId(stateId)
        this.clientData.state = stateId;
    }

    GetallCountryCOdess(event: any) {
        this.validateContactPhoneNumber(event);
    }

    MobilenumberValidation(event: any) {
        this.validateContactPhoneNumber(event);
    }

    onNationalPhoneChange(value: string): void {
        let digits = this.extractNationalDigits(value);
        if (this.maxNationalDigitCount) {
            digits = digits.slice(0, this.maxNationalDigitCount);
        }
        const formatted = digits ? this.formatNationalAsYouType(digits) : '';
        this.nationalPhoneNumber = formatted;
        this.syncStoredPhoneNumber();
        this.validateContactPhoneNumber(this.singleContactDetail.phoneNumber);
    }

    onNationalPhoneKeydown(event: KeyboardEvent): void {
        if (event.ctrlKey || event.metaKey || event.altKey) {
            return;
        }

        const navigationKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (navigationKeys.includes(event.key)) {
            return;
        }

        if (!/^\d$/.test(event.key)) {
            event.preventDefault();
            return;
        }

        const input = event.target as HTMLInputElement;
        const hasSelection = input.selectionStart !== input.selectionEnd;
        if (!hasSelection && this.getNationalDigits().length >= this.maxNationalDigitCount) {
            event.preventDefault();
        }
    }

    get phoneMaskGhost(): string {
        const example = this.phoneFormatExample;
        const typed = this.nationalPhoneNumber || '';
        if (!example) {
            return '';
        }

        let ghost = '';
        for (let i = 0; i < example.length; i++) {
            ghost += i < typed.length ? ' ' : example.charAt(i);
        }
        return ghost;
    }

    get maxNationalDigitCount(): number {
        return this.nationalDigitLimit || 15;
    }

    get phoneInputMaxLength(): number {
        return this.phoneFormatExample ? this.phoneFormatExample.length : 15;
    }

    getNationalDigits(): string {
        return (this.nationalPhoneNumber || '').replace(/\D/g, '');
    }

    private extractNationalDigits(value: string): string {
        let digits = (value || '').replace(/\D/g, '');
        const callingCode = this.phoneDialCode?.replace('+', '');
        if (callingCode && digits.startsWith(callingCode) && digits.length > callingCode.length + 4) {
            digits = digits.slice(callingCode.length);
        }
        if (this.nationalDigitLimit && digits.length > this.nationalDigitLimit && digits.charAt(0) === '0') {
            digits = digits.substring(1);
        }
        return digits;
    }

    private formatNationalAsYouType(digits: string): string {
        let nationalDigits = (digits || '').replace(/\D/g, '');
        if (!nationalDigits) {
            return '';
        }
        if (this.nationalDigitLimit && nationalDigits.length > this.nationalDigitLimit && nationalDigits.charAt(0) === '0') {
            nationalDigits = nationalDigits.substring(1);
        }
        if (this.nationalDigitLimit) {
            nationalDigits = nationalDigits.slice(0, this.nationalDigitLimit);
        }
        if (this.phoneFormatExample) {
            return this.formatWithExamplePattern(nationalDigits);
        }
        if (!this.Phonecountrycode) {
            return nationalDigits;
        }

        try {
            const formatter = new AsYouTypeFormatter(this.Phonecountrycode);
            let formatted = '';
            for (const digit of nationalDigits) {
                formatted = formatter.inputDigit(digit);
            }
            return formatted || nationalDigits;
        } catch {
            return nationalDigits;
        }
    }

    private formatWithExamplePattern(digits: string): string {
        let digitIndex = 0;
        let formatted = '';
        for (const character of this.phoneFormatExample) {
            if (digitIndex >= digits.length) {
                break;
            }
            if (/\d/.test(character)) {
                formatted += digits.charAt(digitIndex);
                digitIndex++;
            } else {
                formatted += character;
            }
        }
        return formatted;
    }

    private updatePhonePlaceholder(): void {
        if (!this.Phonecountrycode) {
            this.phoneFormatExample = '';
            this.nationalDigitLimit = 15;
            this.phonePlaceholder = this.l('EnterMobileNumber');
            return;
        }

        try {
            const phoneUtil = PhoneNumberUtil.getInstance();
            let example = null;
            try {
                example = phoneUtil.getExampleNumberForType(this.Phonecountrycode, PhoneNumberType.MOBILE);
            } catch {
                example = null;
            }
            if (!example) {
                example = phoneUtil.getExampleNumber(this.Phonecountrycode);
            }

            const significantNumber = example ? phoneUtil.getNationalSignificantNumber(example) : '';
            this.nationalDigitLimit = significantNumber?.length || 15;
            this.phoneFormatExample = example
                ? this.formatExampleWithoutTrunkPrefix(phoneUtil, example, significantNumber)
                : '';
            this.phonePlaceholder = this.phoneFormatExample || this.l('EnterMobileNumber');
        } catch {
            this.phoneFormatExample = '';
            this.nationalDigitLimit = 15;
            this.phonePlaceholder = this.l('EnterMobileNumber');
        }
    }

    private formatExampleWithoutTrunkPrefix(phoneUtil: PhoneNumberUtil, example: any, significantNumber: string): string {
        const nationalFormatted = phoneUtil.format(example, PhoneNumberFormat.NATIONAL);
        if (!significantNumber) {
            return nationalFormatted;
        }

        const formattedDigits = nationalFormatted.replace(/\D/g, '');
        if (formattedDigits === significantNumber || !formattedDigits.endsWith(significantNumber)) {
            return nationalFormatted;
        }

        const extraPrefixCount = formattedDigits.length - significantNumber.length;
        let removed = 0;
        const withoutTrunkPrefix = nationalFormatted.replace(/\d/g, (digit) => {
            if (removed < extraPrefixCount) {
                removed++;
                return '';
            }
            return digit;
        });

        return withoutTrunkPrefix.replace(/^\D+/, '').replace(/\s+/g, ' ').trim();
    }

    private applySelectedCountry(country: CountryMasterDto): void {
        if (!country) {
            return;
        }

        this.mobilephoneFlag = country.tld || '';
        this.Phonecountrycode = country.iso2;
        const rawCode = (country.phone_code || '').toString().trim();
        this.phoneDialCode = rawCode
            ? (rawCode.startsWith('+') ? rawCode : '+' + rawCode.replace(/^\+/, ''))
            : '';
        this.updatePhonePlaceholder();
    }

    private applyDefaultPhoneCountry(): void {
        if (!this.allCountryCOde?.length) {
            this.updatePhonePlaceholder();
            return;
        }

        if (this.Phonecountrycode) {
            const current = this.allCountryCOde.find((country) => country.iso2 === this.Phonecountrycode);
            if (current) {
                this.applySelectedCountry(current);
                return;
            }
        }

        if (this.clientData?.countryId) {
            const byClientCountry = this.allCountryCOde.find((country) => country.id === this.clientData.countryId);
            if (byClientCountry) {
                this.applySelectedCountry(byClientCountry);
                return;
            }
        }

        this.updatePhonePlaceholder();
    }

    private applyCountryFromStoredNumber(phone: string): void {
        const prefixMatch = /^\(\+\s?(\d{1,4})\)/.exec(phone || '') || /^\+(\d{1,4})/.exec(phone || '');
        const callingCode = prefixMatch ? prefixMatch[1] : null;
        if (callingCode) {
            this.phoneDialCode = '+' + callingCode;
        }

        try {
            const phoneUtil = PhoneNumberUtil.getInstance();
            const parsed = phoneUtil.parseAndKeepRawInput(this.toParseablePhoneNumber(phone), this.Phonecountrycode);
            const region = phoneUtil.getRegionCodeForNumber(parsed);
            const countryByRegion = region ? this.allCountryCOde?.find((country) => country.iso2 === region) : null;
            if (countryByRegion) {
                this.applySelectedCountry(countryByRegion);
                return;
            }
            if (region) {
                this.Phonecountrycode = region;
            }
        } catch {
        }

        if (callingCode && this.allCountryCOde?.length) {
            const selectedCountry = this.allCountryCOde.find((country) => country.iso2 === this.Phonecountrycode);
            if (selectedCountry?.phone_code?.replace('+', '') === callingCode) {
                this.applySelectedCountry(selectedCountry);
                return;
            }

            const matchedCountry = this.allCountryCOde.find((country) => country.phone_code?.replace('+', '') === callingCode);
            if (matchedCountry) {
                this.applySelectedCountry(matchedCountry);
                return;
            }
        }

        this.updatePhonePlaceholder();
    }

    private syncStoredPhoneNumber(): void {
        if (!this.getNationalDigits()) {
            this.singleContactDetail.phoneNumber = null;
            return;
        }

        if (!this.phoneDialCode) {
            this.singleContactDetail.phoneNumber = this.nationalPhoneNumber || null;
            return;
        }

        this.singleContactDetail.phoneNumber = '(' + this.phoneDialCode + ')' + (this.nationalPhoneNumber || '');
    }

    private hydratePhoneFromStoredValue(phone: string): void {
        if (!phone) {
            this.nationalPhoneNumber = '';
            this.updatePhonePlaceholder();
            this.setPhoneValidationState(true);
            return;
        }

        const prefixMatch = /^\(\+\s?(\d{1,4})\)(.*)$/.exec(phone);
        this.applyCountryFromStoredNumber(phone);
        const nationalPart = prefixMatch ? prefixMatch[2] : phone;
        this.nationalPhoneNumber = this.formatNationalAsYouType(nationalPart);
        this.syncStoredPhoneNumber();
        this.validateContactPhoneNumber(this.singleContactDetail.phoneNumber);
    }

    private toParseablePhoneNumber(phone: string): string {
        const withPrefix = /^\(\+\s?(\d{1,4})\)(.*)$/.exec(phone);
        if (withPrefix) {
            return `+${withPrefix[1]}${withPrefix[2].replace(/\D/g, '')}`;
        }

        return phone.replace(/[^\d+]/g, '');
    }

    private setPhoneValidationState(isValid: boolean): void {
        this.validatenymber = isValid;
        this.mobilenumber = isValid;
        const control = this.orgMobPhoneNgModel?.control;
        if (!control) {
            return;
        }

        const currentErrors = control.errors || {};
        if (isValid) {
            if (!currentErrors['invalid']) {
                return;
            }
            const otherErrors = { ...currentErrors };
            delete otherErrors['invalid'];
            control.setErrors(Object.keys(otherErrors).length ? otherErrors : null);
            return;
        }

        control.setErrors({ ...currentErrors, invalid: true });
    }

    validateContactPhoneNumber(event: any): void {
        const phone = event != null ? event.toString().trim() : '';
        const nationalDigits = this.getNationalDigits() || (phone.replace(/^\(\+\s?\d{1,4}\)/, '').replace(/\D/g, ''));
        if (!phone || !nationalDigits) {
            this.setPhoneValidationState(true);
            return;
        }

        const parseableNumber = this.toParseablePhoneNumber(phone);

        try {
            const phoneUtil = PhoneNumberUtil.getInstance();
            const number = phoneUtil.parseAndKeepRawInput(parseableNumber, this.Phonecountrycode);
            const isValid = this.Phonecountrycode
                ? phoneUtil.isValidNumberForRegion(number, this.Phonecountrycode) || phoneUtil.isValidNumber(number)
                : phoneUtil.isValidNumber(number);
            this.setPhoneValidationState(isValid);
        } catch {
            this.setPhoneValidationState(false);
        }
    }

    BusinessPhone(selectedText: CountryMasterDto) {
        const existingDigits = this.getNationalDigits();
        this.applySelectedCountry(selectedText);
        this.nationalPhoneNumber = this.formatNationalAsYouType(existingDigits);
        this.syncStoredPhoneNumber();
        this.validateContactPhoneNumber(this.singleContactDetail.phoneNumber);
    }

    filterItems(value: string) {
        const filterValue = value.toLowerCase();
        if (filterValue)
            this.filterCountryCOde = this.allCountryCOde.filter(option => option.phone_code.toLowerCase().includes(filterValue));
        else
            this.filterCountryCOde = this.allCountryCOde
    }

    checknumber() {
        this.hydratePhoneFromStoredValue(this.singleContactDetail.phoneNumber);
    }

    GetallCountryCOde() {
        if (!AppConsts.allCountry) {
            this._countryStateCityAppserviceServiceProxy.getAllCountry().subscribe(result => {
                AppConsts.allCountry = result; this.GetallCountryCOdeAfterApi(result);
            });
        } else { this.GetallCountryCOdeAfterApi(AppConsts.allCountry); }
    }
    GetallCountryCOdeAfterApi(result) {
        this.allCountryCOde = result.filter((country) => {
            return country.phone_code !== '';
        }).sort((a, b) => a.phone_code.localeCompare(b.phone_code));
        if (this.singleContactDetail?.phoneNumber) {
            this.checknumber();
        } else {
            this.applyDefaultPhoneCountry();
        }
        this.updateZipCountryFromSelection();
    }

    selectedCountryIso2 = '';
    zipCodeInvalid = false;

    get zipCodeMaxLength(): number {
        return getPostalCodeMaxLength(this.selectedCountryIso2);
    }

    onZipCodeKeydown(event: KeyboardEvent): void {
        if (event.ctrlKey || event.metaKey || event.altKey) {
            return;
        }
        const navigationKeys = ['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
        if (navigationKeys.includes(event.key) || event.key.length !== 1) {
            return;
        }
        if (!getPostalCodeRule(this.selectedCountryIso2).charPattern.test(event.key)) {
            event.preventDefault();
            return;
        }
        const input = event.target as HTMLInputElement;
        const hasSelection = input.selectionStart !== input.selectionEnd;
        if (!hasSelection && (this.clientData.zipCode || '').length >= this.zipCodeMaxLength) {
            event.preventDefault();
        }
    }

    onZipCodeChange(value: string): void {
        const sanitized = sanitizePostalCode(value, this.selectedCountryIso2);
        if ((this.clientData.zipCode || '') !== sanitized) {
            this.clientData.zipCode = sanitized;
        }
        this.zipCodeInvalid = !!sanitized && !isPostalCodeValid(sanitized, this.selectedCountryIso2);
        const input = this.zipCodeInput?.nativeElement;
        if (input && input.value !== sanitized) {
            input.value = sanitized;
        }
    }

    private updateZipCountryFromSelection(): void {
        if (!this.allCountryCOde?.length) {
            return;
        }
        const country = this.clientData?.countryId
            ? this.allCountryCOde.find((item) => item.id === this.clientData.countryId)
            : null;
        this.selectedCountryIso2 = (country?.iso2 || '').toUpperCase();
        this.onZipCodeChange(this.clientData?.zipCode || '');
    }
}
